<div [ngClass]="{'page-container': currentPortal !== PortalType.Normal}">

  <div class="header-container m2 mb2">
    <section>
      <mat-form-field class="filter-form-field-wide">
        <mat-label>Search by policyholder group by name OR number</mat-label>
        <input #policyholderGroupSearch (input)="searchPolicyholderGroup($event)"
               [formControl]="policyholderGroupFormControl" data-qa="qa-input-policyholder-group"
               matInput
               type="text">
      </mat-form-field>
    </section>
    <span class="header-spacer"></span>
    <div>
      <button [routerLink]="getRouteForAddPolicyholderGroup()" color="accent" mat-raised-button>
        <mat-icon>add</mat-icon>
        Policyholder Group
      </button>
    </div>
  </div>

  <div *ngIf="policyholderGroupDataSource"  class="mat-elevation-z8 table-container">

    <table #policyholderGroupSort="matSort" (matSortChange)="sortData($event)"
           [dataSource]="policyholderGroupDataSource"
           mat-table matSort multiTemplateDataRows>

      <ng-container [matColumnDef]="TableColumns.Icons">
        <th *matHeaderCellDef mat-header-cell></th>
        <td *matCellDef="let row" mat-cell>
          <mat-icon (click)="editEntry($event, row.policyholderGroupId)" class="table-icon"
                    matTooltip="EDIT Policyholder Group">edit
          </mat-icon>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.PolicyholderGroupId">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Id</th>
        <td *matCellDef="let row" mat-cell>{{row.policyholderGroupId}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.PolicyholderGroupNumber">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Group Number</th>
        <td *matCellDef="let row" mat-cell>{{row.policyholderGroupNumber}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.Name">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Group Name</th>
        <td *matCellDef="let row" mat-cell>{{row.name | slice:0:50}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.Broker">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Broker</th>
        <td *matCellDef="let row" mat-cell>{{row.broker?.name}}</td>
      </ng-container>Cenral Group

      <ng-container [matColumnDef]="TableColumns.CentralGroup">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Central Group</th>
        <td *matCellDef="let row" mat-cell>{{row.policyholderGroupParent?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.BusinessType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Business Type</th>
        <td *matCellDef="let row" mat-cell>{{row.businessType?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.UnderwritingCategory">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Underwriting Category</th>
        <td *matCellDef="let row" mat-cell>{{row.underwritingCategory?.name}}</td>
      </ng-container>

      <ng-container [matColumnDef]="TableColumns.GroupCountRange">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Group Count Range</th>
        <td *matCellDef="let row" mat-cell>{{row.groupCountRange?.description}}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td *matCellDef="let row" [attr.colspan]="policyholderGroupDisplayedColumns.length" mat-cell>
          <div [@detailExpand]="row == policyholderGroupExpandedRow ? 'expanded' : 'collapsed'"
               class="row-detail-container">
            <b>License Number: </b>{{row?.businessLicenseNumber}}<br>
            <b>License Expiry: </b>{{row.businessLicenseExpiryDate | date: dateFormat}}<br>
            <b>Bank Account: </b>{{row?.bankAccount?.name}}<br>
            <b>GST Number: </b>{{row?.gstNumber}}<br>
            <b>GST Override: </b>{{row?.gstOverride}}<br>
            <b>Vat Override: </b>{{row?.vatOverride}}<br>
            <b>Vat Number: </b>{{row?.vatNumber}}<br>
            <b>Sanction Indicator: </b>{{row?.sanctionIndicator}}<br>
            <b>Sanction Reference: </b>{{row?.sanctionReference}}<br>
            <b>Sanction Check Date: </b>{{row?.sanctionCheckDate | date: dateFormat}}<br>
            <b>Business Type: </b>{{row?.businessType?.name}}<br>
            <b>Created By: </b>{{row?.createdBy}}<br>
            <b>Created Date: </b>{{row?.created | date: dateTimeFormat}}<br>
            <b>Updated By: </b>{{row?.updatedBy}}<br>
            <b>Updated Date: </b>{{row?.updated | date: dateTimeFormat}}<br>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="policyholderGroupDisplayedColumns" mat-header-row></tr>
      <tr (click)="policyholderGroupExpandedRow = policyholderGroupExpandedRow === row ? null : row"
          *matRowDef="let row; columns: policyholderGroupDisplayedColumns;"
          [class.expanded-row]="policyholderGroupExpandedRow == row"
          class="row"
          mat-row>
      </tr>
      <tr *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row" mat-row></tr>

    </table>

    <mat-paginator #policyholderGroupPaginator (page)="pageChanged($event)"
                   [length]="policyholderGroupTableControl.length"
                   [pageIndex]="0"
                   [pageSizeOptions]="policyholderGroupTableControl.pageSizeOptions"
                   [pageSize]="policyholderGroupTableControl.pageSize">
    </mat-paginator>

  </div>
</div>
